// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentBookingState from './data'

export default function AppointmentBookingStateFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentBookingState">
      <AppointmentBookingState {...props}>
        {children}
      </AppointmentBookingState>
    </Flow>
  )
}
